
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};

@Injectable()
export class LimitMaintenanceService {
    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }


    getAllBranchLimits() {
        return this.http.get(`setups/branch`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }

    getAllCompanyLimits() {
        return this.http.get(`setups/company`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }

    getAllObligorLimits() {
        return this.http.get(`credit/limitvalidations/obligor-limit`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }

    getAllSectorLimits() {
        return this.http.get(`setups/sectors`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }


    updateBranchLimits(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`setups/branches/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateCompanyLimits(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`setups/companys/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    addSector(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/sectors`, bodyObj)
           .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    

    updateSectorLimits(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`setups/sectors/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    deleteSector(sectorId) {
        return this.http.delete(`setups/sectors/${sectorId}`)
           .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    

    addUpdateObligorLimits(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/limitvalidations/obligor-limit`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    // updateObligorLimits(body, riskRatingId) {
    //     let bodyObj = JSON.stringify(body);
    //     return this.http.put(`credit/limitvalidations/obligor-limit/${riskRatingId}`, bodyObj)
    //         .map((res: Response) => res.json())
    //         .catch((error: any) => Observable
    //             .throw(error.json().error || 'Server error'));
    // }

    deleteObligor(riskRatingId) {
        return this.http.delete(`credit/limitvalidations/obligor-limit/${riskRatingId}`)
           .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    

    updateSingleObligorLimits(body, Id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`setups/single/obligor-limit/${Id}`, bodyObj)
           .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
}